import React from 'react'
import { useSelector } from 'react-redux'
import { HOME_PAGE_GAMES_VARIANTS } from 'constants/uiConfig'
import HomePageGamesV1 from './HomePageGamesV1'
import HomePageGamesV2 from './HomePageGamesV2'

/**
 * HomePageGames orchestrator chooses the variant based on uiConfig
 *
 * Supports both string ("v2") and object ({ variant: "v2" }) forms.
 */
const HomePageGames = (props) => {
  const { general } = useSelector(state => state.uiConfig)
  const sectionConfig = general?.homePageGamesVariant || {}
  const variantFromConfig = typeof sectionConfig === 'object' && sectionConfig.variant
    ? sectionConfig.variant
    : sectionConfig

  if (variantFromConfig === HOME_PAGE_GAMES_VARIANTS.V2) {
    return <HomePageGamesV2 {...props} />
  }

  // default fallback to V1 to maintain backward compatibility
  return <HomePageGamesV1 {...props} />
}

export default HomePageGames
